export const ExperienceData = [
  {
    company: "EMIDS",
    designation: "Senior Software Engineer",
    dateJoining: "Feb 2026",
    dateEnd: "Present",
    companyLogo:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOia0dcHgXc1xEPnHFLguvlBEnEjJ5u8bb8CsQYYGzAtlKd_NMjZl2J8U7Jr8ql7TBsmU&usqp=CAU",
    work: [
      "Contributing to the frontend and service-layer modernization of a large enterprise platform, helping migrate a legacy codebase to modular <strong>React/Next.js micro-frontends</strong> across <strong>6 application modules</strong> to enable independent team releases.",
      "Collaborating on architecture for <strong>micro-frontend boundaries</strong>, backend integration workflows, and deployment strategy, supporting a shift toward decoupled, independent release cycles.",
      "Helping build shared, <strong>TypeScript-based platform foundations</strong> — reusable components, API orchestration, and cross-app state management — to standardize data delivery across multiple teams.",
      "Driving engineering quality through <strong>automated testing, observability, and CI/CD improvements</strong>, helping raise release stability and test coverage toward <strong>90%</strong> across core user journeys.",
    ],
  },
  {
    company: "Accenture",
    designation: "Full Stack Engineering Senior Analyst",
    dateJoining: "July 2021",
    dateEnd: "Jan 2026",
    companyLogo:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOia0dcHgXc1xEPnHFLguvlBEnEjJ5u8bb8CsQYYGzAtlKd_NMjZl2J8U7Jr8ql7TBsmU&usqp=CAU",
    work: [
      "Led <strong>full-stack development</strong> of enterprise platforms serving <strong>50K+ users</strong>, designing scalable APIs and data flows for high-volume workflows.",
      "Engineered <strong>AI-powered product features</strong> on <strong>LLM APIs</strong> — intelligent search, summarization, and contextual retrieval (<strong>RAG</strong>) — cutting search-and-summarization time by <strong>~60%</strong>.",
      "Built reusable <strong>backend and frontend foundations</strong> (component systems, service integrations, and data-orchestration layers) adopted across <strong>6 teams</strong> to accelerate delivery.",
      "Drove <strong>architecture decisions and release planning</strong> while mentoring engineers across cross-functional teams.",
    ],
  },
  {
    company: "HEU Technologies",
    designation: "Frontend Developer Intern",
    dateJoining: "Dec 2020",
    dateEnd: "May 2021",
    companyLogo: "https://www.heu.ai/static/media/lp.39404079.png",
    work: [
      "Built modern SPAs for <strong>eCommerce and EdTech</strong> using <strong>React.js, Redux, and JavaScript (ES6+)</strong>, delivering engagement-driven modules (<strong>shopping cart, checkout, dashboards, QA forums</strong>) that improved <strong>conversion and retention</strong>.",
      "Developed reusable, <strong>TypeScript-ready UI components</strong> and integrated <strong>REST APIs</strong> with robust error handling, establishing patterns later scaled across product teams.",
      "Ensured <strong>a11y compliance</strong> with <strong>semantic HTML, ARIA attributes, and keyboard navigation</strong>, expanding reach and adoption across diverse audiences.",
    ],
  },
];
